import React, { useState, useEffect } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import DynamicForm from 'components/Shared/DynamicForm';
import { Select, MenuItem, Grid, InputLabel, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  hidden: {
    display: "none"
  },
  visible: {
    display: "flex"
  }
}))

const availableForms = [
  { form: "ASTMC39", type: "concrete" },
  { form: "AASHTOT244", type: "reinforcing steel" },
  { form: "AASHTOT19", type: "soils & aggregates" },
  { form: "AASHTOT236", type: "soils & aggregates" },
  { form: "AASHTOT267", type: "soils & aggregates" },
  { form: "AASHTOT27", type: "soils & aggregates" },
  { form: "AASHTOT288", type: "soils & aggregates" },
  { form: "AASHTOT289", type: "soils & aggregates" },
  { form: "AASHTOT89", type: "soils & aggregates" },
  { form: "AASHTOT90", type: "soils & aggregates" },
  { form: "ASTMD4767", type: "soils & aggregates" },
  { form: "SCT34", type: "soils & aggregates" }
]

const tabs = [
  new Tab({ label: "Form", value: "Form" }),
  new Tab({ label: "Edit/Playground", value: "Edit/Playground" })
]

const FormExplorer = () => {
  const [activeTab, setActiveTab] = useState("Form");
  const [selectedForm, setSelectedForm] = useState('');
  const [schema, setSchema] = useState(undefined);
  const classes = useStyles();

  const handleChange = (e) => {
    setSelectedForm(e.target.value);
  }

  useEffect(() => {
    async function asyncEffect() {
      const _schema_ = await import(`__tests__/__mocks__/${selectedForm}.schema.json`);
      setSchema(_schema_.default);
    };
    selectedForm && asyncEffect();
  }, [selectedForm])

  const handleSchemaChange = (event) => {
    let updatedSchema;
    try {
      updatedSchema = JSON.parse(event.target.value);
      event.target.value = JSON.stringify(updatedSchema, null, 2);
    } catch (e) {
      return;
    };
    updatedSchema && setSchema(updatedSchema);
  }

  return (
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
      <Grid container justify='center' className={activeTab === "Form" ? classes.visible : classes.hidden}>
        <Grid item xs={8} style={{ padding: 24 }}>
          <InputLabel id="label">Select a Form to Load</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedForm}
            onChange={handleChange}
            style={{ width: "100%" }}
          >
            {availableForms.map(r => (<MenuItem value={r.form} key={r.form}>{r.form} / {r.type}</MenuItem>))}
          </Select>
          <br />
          {schema && <DynamicForm jsonSchema={schema} onSubmit={(e) => { alert(JSON.stringify(e, null, 2)); console.log(JSON.stringify(e, null, 2)) }}></DynamicForm>}
        </Grid>
      </Grid>

      <Grid container justify='center' className={activeTab === "Edit/Playground" ? classes.visible : classes.hidden}>
        <Grid item xs={8} style={{ padding: 24 }}>
          <TextField onChange={handleSchemaChange} multiline style={{ width: "100%" }}
            defaultValue={JSON.stringify(schema, null, 2)}
            rows={45} variant="outlined">
          </TextField>
        </Grid>
      </Grid>

    </TabbedPage>
  )
}

export default FormExplorer;